import { takeEvery, all } from "redux-saga/effects";

import {
  _sharedWorkerFetchBook, _sharedWorkerFetchLanguageFolders,
  _sharedWorkerFetchMainTreeAllData
} from "@/shared/store/mainTree/saga";

import { mainTreeActionConstants } from "../actions";

export default function* systemSaga() {
  yield all([
    takeEvery(mainTreeActionConstants.FETCH_MAIN_TREE_ALL_DATA, _sharedWorkerFetchMainTreeAllData),
    takeEvery(mainTreeActionConstants.FETCH_LANGUAGE_FOLDERS, _sharedWorkerFetchLanguageFolders),
    takeEvery(mainTreeActionConstants.FETCH_BOOK, _sharedWorkerFetchBook),
  ]);
}
